import "./Footer.css";

import logo from "../../assets/logo/logo.png";

import {

    FaPhoneAlt,
    FaEnvelope,
    FaMapMarkerAlt,
    FaLinkedinIn,
    FaFacebookF,
    FaInstagram,
    FaArrowUp

} from "react-icons/fa";

function Footer() {

    const year = new Date().getFullYear();

    const scrollTop = () => {

        window.scrollTo({

            top:0,
            behavior:"smooth"

        });

    };

    return (

        <footer className="footer">

            <div className="container-custom">

                <div className="row gy-5">

                    {/* Company */}

                    <div className="col-lg-4">

                        <div className="footer-brand">

                            <img
                                src={logo}
                                alt="TIGI Industries"
                            />

                            <p>

                                TIGI Industries India Pvt. Ltd. delivers
                                innovative, sustainable and reliable
                                industrial packaging solutions designed
                                to meet the evolving needs of modern
                                businesses.

                            </p>

                            <div className="footer-social">

                                <a href="#">

                                    <FaLinkedinIn />

                                </a>

                                <a href="#">

                                    <FaFacebookF />

                                </a>

                                <a href="#">

                                    <FaInstagram />

                                </a>

                            </div>

                        </div>

                    </div>

                    {/* Quick Links */}

                    <div className="col-lg-2 col-md-6">

                        <h4>

                            Quick Links

                        </h4>

                        <ul>

                            <li><a href="#home">Home</a></li>

                            <li><a href="#about">About</a></li>

                            <li><a href="#products">Products</a></li>

                            <li><a href="#contact">Contact</a></li>

                        </ul>

                    </div>

                    {/* Products */}

                    <div className="col-lg-3 col-md-6">

                        <h4>

                            Products

                        </h4>

                        <ul>

                            <li>Flexible Packaging</li>

                            <li>HDPE Carboys</li>

                            <li>LDPE Films</li>

                            <li>Ziplock Pouches</li>

                            <li>FIBC Bags</li>

                            <li>Woven Bags</li>

                        </ul>

                    </div>

                    {/* Contact */}

                    <div className="col-lg-3">

                        <h4>

                            Contact

                        </h4>

                        <ul className="footer-contact">

                            <li>

                                <FaMapMarkerAlt />

                                <span>

                                    Plot No.26, B Nanji Industrial Estate,
                                    Kharadpada, Silvassa - 396230

                                </span>

                            </li>

                            <li>

                                <FaPhoneAlt />

                                <span>

                                    +91 90042 90293

                                </span>

                            </li>

                            <li>

                                <FaEnvelope />

                                <span>

                                    sales@tigiindustries.in

                                </span>

                            </li>

                        </ul>

                    </div>

                </div>

                <hr />

                <div className="footer-bottom">

                    <p>

                        © {year} TIGI Industries India Pvt. Ltd.
                        All Rights Reserved.

                    </p>

                    <p>

                        Designed & Developed by <span> </span>

                        <a
                            href="https://adyah.co.in"
                            target="_blank"
                            rel="noreferrer"
                        >

                            Adyah Consultancy Services

                        </a>

                    </p>

                </div>

            </div>

            <button
                className="scroll-top"
                onClick={scrollTop}
            >

                <FaArrowUp />

            </button>

        </footer>

    );

}

export default Footer;